
export const products=[
{
    id:1,
    img:"https://i.ibb.co/0j08rhc/screencapture-castbox-fm-episode-id2598530-id318045140-2021-11-12-13-34-57-1.png",
    link:"http://lama.dev",
},
{
    id:2,
    img:"https://i.ibb.co/0j08rhc/screencapture-castbox-fm-episode-id2598530-id318045140-2021-11-12-13-34-57-1.png",
    link:"http://lama.dev",
},
{
    id:3,
    img:"https://i.ibb.co/NTkj94j/screencapture-sololearn-profile-20437206-2021-11-12-13-30-38.pngb.co/XYds7ws",
    link:"http://lama.dev",
},
{
    id:4,
    img:"https://i.ibb.co/4SfymPN/screencapture-shape-so-2021-11-12-13-31-56.png",
    link:"http://lama.dev",
},
{
    id:5,
    img:"https://i.ibb.co/NTkj94j/screencapture-sololearn-profile-20437206-2021-11-12-13-30-38.pngb.co/XYds7ws",

    link:"http://lama.dev",
},{
    id:6,
    img:"https://i.ibb.co/0j08rhc/screencapture-castbox-fm-episode-id2598530-id318045140-2021-11-12-13-34-57-1.png",

    link:"http://lama.dev",
},







]